module.exports = __webpack_public_path__ + "img/img0.42e753ae.jpg";